<template>
  <section class="contenedor" style="background-color: #f6f3ee; padding-top: 60px;"> 
    <div class="contenedor-imagen">
      <div class="texto-title">
        Agenda una videollamada 360° con un asesor personal
      </div>
    </div>
    <div class="texto-info">
      Explora cada detalle, interior y exterior, de nuestros revolucionarios vehículos 100% eléctricos, 
      a través de la innovadora tecnología Kia DX Studio. Despeja dudas sobre las características, 
      atributos, ventajas, colores y configuraciones de nuestros EVs.
      ¡Agenda tu videollamada ahora y conoce tu próximo EV en Kia DX Studio!

    </div>
        
  </section>
</template>


<script>

export default {
  name: "Home",
  components: {},
};
</script>



<style scoped>
.margen-h {
  width: 100%;
  text-align: center; 
}

.contenedor-imagen {
  position: relative;
  width: 100%;
}

.texto-title {
  display: flex;
  justify-content: center;
  font-size: 35px;
  font-weight: bold;
  text-align: center;

}

.texto-info {
  width: 60%;
  margin: 0 auto;
  font-size: 18px;
  text-align: center;
  line-height: 1.5;
  padding-bottom: 3rem;
  padding-top: 1rem;
  color:#05141F;
}

.img-card{
    display: flex;
    justify-content: flex-end;
}
</style>
